import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ShieldAlert, CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export default function DenySessionPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Geçersiz bağlantı — token eksik.");
    }
  }, [token]);

  const confirmDeny = async () => {
    setStatus("loading");
    try {
      const { data } = await api.post("/auth/deny-session", { token });
      setStatus("success");
      setMessage(data?.message || "Tüm oturumlar sonlandırıldı.");
    } catch (err) {
      setStatus("error");
      setMessage(err?.response?.data?.detail || "Bağlantı doğrulanamadı.");
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 grid place-items-center px-4 py-8">
      <div className="w-full max-w-md bg-white rounded-sm border border-zinc-200 p-6 space-y-4">
        <div className="flex items-center gap-2">
          <ShieldAlert className="h-5 w-5 text-red-600" />
          <h1 className="text-lg font-semibold text-zinc-900">Şüpheli giriş bildirimi</h1>
        </div>

        {status === "idle" && (
          <>
            <p className="text-sm text-zinc-700 leading-relaxed">
              Bu bağlantıyı hesabınıza <strong>başka biri</strong> giriş yaptığını düşündüğünüz için
              tıkladıysanız, aşağıdaki butonla <strong>tüm aktif oturumları sonlandırabilirsiniz</strong>.
            </p>
            <p className="text-xs text-zinc-500 leading-relaxed">
              Butona bastıktan sonra hesabınızı korumak için mümkün olan en kısa sürede
              <strong> şifrenizi değiştirmenizi</strong> öneririz.
            </p>
            <Button
              onClick={confirmDeny}
              className="w-full bg-red-600 hover:bg-red-700 text-white rounded-sm h-10"
              data-testid="confirm-deny-btn"
            >
              Evet, tüm oturumları sonlandır
            </Button>
            <div className="text-center text-xs text-zinc-500">
              Yanlışlıkla mı geldiniz? <Link to="/giris" className="text-zinc-900 underline">Giriş sayfasına dön</Link>
            </div>
          </>
        )}

        {status === "loading" && (
          <div className="flex items-center gap-2 text-sm text-zinc-700 py-4">
            <Loader2 className="h-4 w-4 animate-spin" />
            İşleminiz gerçekleştiriliyor…
          </div>
        )}

        {status === "success" && (
          <div className="rounded-sm border border-emerald-200 bg-emerald-50 p-4 space-y-3">
            <div className="flex items-center gap-2 text-emerald-800 font-semibold">
              <CheckCircle2 className="h-5 w-5" /> Oturumlar sonlandırıldı
            </div>
            <p className="text-sm text-emerald-900">{message}</p>
            <Link
              to="/sifremi-unuttum"
              className="inline-block text-sm underline text-emerald-900"
            >
              Şimdi şifrenizi sıfırlayın →
            </Link>
          </div>
        )}

        {status === "error" && (
          <div className="rounded-sm border border-red-200 bg-red-50 p-4 space-y-2">
            <div className="flex items-center gap-2 text-red-800 font-semibold">
              <XCircle className="h-5 w-5" /> Hata
            </div>
            <p className="text-sm text-red-900">{message}</p>
            <Link to="/giris" className="text-sm underline text-red-900">
              Giriş sayfasına dön
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
